import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { DxTemplateModule } from 'devextreme-angular/core';
import { DxTooltipModule } from 'devextreme-angular';
import { NgIf } from '@angular/common';

@Component({
    selector: 'tooltip-circle',
    templateUrl: 'tooltip-circle.component.html',
    styleUrls: ['tooltip-circle.component.scss'],
    standalone: true,
    imports: [
        NgIf,
        DxTooltipModule,
        DxTemplateModule,
    ],
})
export class TooltipCircleComponent implements OnInit {
	@Input()
	tooltipId: string;

	@Input()
	infoStyle = false;

	constructor() {}

	ngOnInit() {}
}
